import React from "react"
import PageBody from "../../../components/PageBody"
import ProductFileUpload from "../../../components/ProductFileUpload"

const StockCancelImages = (props: any) => {
    const { imgs, setImgs } = props

    return (
        <PageBody>
            <div className="nutri-title mb-3">Hình ảnh</div>
            <ProductFileUpload
                handleChangeFile={(files: any) => {
                    setImgs(files)
                }}
                fileTypes={["JPEG", "PNG", "GIF", "JPG", "jpeg", "png", "gif", "jpg", ]}
                imgs={imgs}
                disabled={props?.disabled  || false}
            />
        </PageBody>
    )
}

export default StockCancelImages